//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { LABEL_MARKS } from './RequestWorkTypes.js'

export default {
  name: 'RequestWorkTypeDoneIndicator',
  props: {
    workType: {
      type: Object,
      required: true
    }
  },
  computed: {
    state: function () {
      if (this.workType.hasDoneReports && !this.workType.hasDoneMultipleReports && !this.workType.donePartiallyIsLast) {
        return 'doneOnce'
      } else if (this.workType.hasDoneMultipleReports && !this.workType.donePartiallyIsLast) {
        return 'doneMultiple'
      } else if (this.workType.hasDoneReports && !this.workType.hasDoneMultipleReports && this.workType.donePartiallyIsLast) {
        return 'doneOnceAndPartial'
      } else if (this.workType.hasDoneMultipleReports && this.workType.donePartiallyIsLast) {
        return 'doneMultipleAndPartial'
      } else if (this.workType.hasDonePartiallyReports) {
        return 'donePartial'
      } else {
        return null
      }
    },
    label: function () {
      switch (this.state) {
        case 'doneOnce':
        case 'doneMultiple':
          return null
        case 'donePartial':
        case 'doneOnceAndPartial':
        case 'doneMultipleAndPartial':
          return LABEL_MARKS.technologicalOperation
        default:
          return null
      }
    },
    icon: function () {
      switch (this.state) {
        case 'doneOnce':
        case 'doneOnceAndPartial':
          return 'mdi-check'
        case 'doneMultiple':
        case 'doneMultipleAndPartial':
          return 'mdi-check-all'
        default:
          return null
      }
    },
    tooltip: function () {
      switch (this.state) {
        case 'doneOnce':
          return 'Работа выполнена только в одном выезде'
        case 'donePartial':
          return 'Работа не выполнена, но выполнялись технологические операции в составе работы'
        case 'doneOnceAndPartial':
          return 'Работа выполнена только в одном выезде, а в последующих выездах выполнялись технологические операции в составе работы'
        case 'doneMultiple':
          return 'Работа выполнена в нескольких выездах'
        case 'doneMultipleAndPartial':
          return 'Работа выполнена в нескольких выездах, а в последующих выездах выполнялись технологические операции в составе работы'
        default:
          return null
      }
    }
  }
}
